import styled from 'styled-components';

const StyledValue = styled.strong`
  font-size: 22px;
`;

const Costs = styled(StyledValue)`
  color: ${(props) => props.theme.colors.imported};
`;

const Savings = styled(StyledValue)`
  color: ${(props) => props.theme.colors.exported};
`;

StyledValue.Costs = Costs;
StyledValue.Savings = Savings;

export default StyledValue;
